import Box from '@mui/material/Box'
import styled from '@mui/material/styles/styled'

export const Subtitle = styled(Box, {
  name: 'Subtitle',
  slot: 'Root',
  skipSx: true,
})`
  font-size: 15px;
`
